import { z } from 'zod';

const NodeIdSchema = z.union([z.string(), z.number()]).transform(String);

const NodeDateSchema = z.string().nullable();

export const PlatformCampaignNodeSchema = z.object({
  id: NodeIdSchema,
  name: z.string(),
  type: z.literal('platform_campaign'),
  startDate: NodeDateSchema,
  endDate: NodeDateSchema,
});

export const MediaRowNodeSchema = z.object({
  id: NodeIdSchema,
  name: z.string(),
  type: z.literal('media_row'),
  startDate: NodeDateSchema,
  endDate: NodeDateSchema,
  children: z.array(PlatformCampaignNodeSchema),
});

export const PlatformNodeSchema = z.object({
  id: NodeIdSchema,
  name: z.string(),
  type: z.literal('platform'),
  children: z.array(MediaRowNodeSchema),
});

export const ChannelNodeSchema = z.object({
  id: NodeIdSchema,
  name: z.string(),
  type: z.literal('channel'),
  children: z.array(PlatformNodeSchema),
});

export const MediaplanNodeSchema = z.object({
  id: NodeIdSchema,
  name: z.string(),
  type: z.literal('mediaplan'),
  startDate: NodeDateSchema,
  endDate: NodeDateSchema,
  children: z.array(ChannelNodeSchema),
});

export const CampaignNodeSchema = z.object({
  id: NodeIdSchema,
  name: z.string(),
  type: z.literal('campaign'),
  children: z.array(MediaplanNodeSchema),
});

// Campaign → mediaplan → channel → platform → media row → platform campaign.
export const MediaMappingMediaplansSchema = z.array(CampaignNodeSchema);

// media_mapping_agent result in a chat message's `metadata.mapping`.
// A media row the agent found no candidate for comes with a null id and an
// empty name.
export const PlanMappingRowSchema = z.object({
  mediarowId: NodeIdSchema,
  platformCampaignId: NodeIdSchema.nullable(),
  platformCampaignName: z.string().nullable(),
  confidenceScore: z.number(),
  decisionSource: z.enum(['deterministic', 'llm', 'user']),
});

export const MediaMappingResultSchema = z.object({
  planMapping: z.array(PlanMappingRowSchema).nullable(),
  // Low-confidence candidates the agent did not accept.
  unmapped: z.array(PlanMappingRowSchema).nullish(),
});
